import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface TeamMemberProps {
  member: {
    id: number;
    name: string;
    role: string;
    specialization: string;
    image: string;
    alt: string;
    certifications: string[];
    linkedin: string;
    email: string;
    imagePosition?: string;
  };
  onViewDetails: (member: any) => void;
}

const TeamMember = ({ member, onViewDetails }: TeamMemberProps) => {
  return (
    <div className="group relative glassmorphic rounded-xl overflow-hidden hover:shadow-premium transition-all duration-500 hover:-translate-y-2">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <div className="relative p-6">
        <div className="relative w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden border-2 border-primary/20 group-hover:border-primary/60 transition-all duration-500">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          <AppImage
            src={member.image}
            alt={member.alt}
            className="w-full h-full object-cover"
            style={{ objectPosition: member.imagePosition || 'center' }}
          />
        </div>

        <div className="text-center mb-4">
          <h3 className="text-xl font-display font-bold text-foreground mb-2 group-hover:text-primary transition-colors duration-300">
            {member.name}
          </h3>
          <p className="text-sm font-semibold text-primary mb-1">{member.role}</p>
          <p className="text-sm text-muted-foreground">{member.specialization}</p>
        </div>

        <div className="flex flex-wrap gap-2 justify-center mb-6">
          {member.certifications.slice(0, 3).map((cert, index) => (
            <span
              key={index}
              className="px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full border border-primary/20"
            >
              {cert}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-center gap-4 mb-4">
          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 rounded-lg bg-muted hover:bg-primary/20 text-muted-foreground hover:text-primary transition-all duration-300"
            aria-label={`${member.name} LinkedIn profiel`}
          >
            <Icon name="GlobeAltIcon" size={20} />
          </a>
          <a
            href={`mailto:${member.email}`}
            className="p-2 rounded-lg bg-muted hover:bg-primary/20 text-muted-foreground hover:text-primary transition-all duration-300"
            aria-label={`Email ${member.name}`}
          >
            <Icon name="EnvelopeIcon" size={20} />
          </a>
        </div>

        <button
          onClick={() => onViewDetails(member)}
          className="w-full px-4 py-2.5 rounded-lg font-semibold text-sm bg-primary/10 text-primary hover:bg-primary hover:text-primary-foreground border border-primary/20 hover:border-primary transition-all duration-300 flex items-center justify-center gap-2"
        >
          <span>Bekijk profiel</span>
          <Icon name="ArrowRightIcon" size={16} />
        </button>
      </div>
    </div>
  );
};

export default TeamMember;